module.exports = __webpack_public_path__ + "media/images/mailer-new-survey-request-9ced5c7e5de36a684f1410fe4be19fba.png";